// `/admin/webhooks/inbox/$id` (croqui `screens/admin/webhooks-recebidos.tsx`, frame
// `EventoRecebido`).
//
// Este componente é o CONTEÚDO do `RouteDrawer` da rota-pai: o cabeçalho (tipo do evento,
// id, pílula e o botão de fechar) é do drawer, e a lista continua desenhada embaixo -
// inclusive em deep link.
//
// O reprocesso exige step-up (`ADMIN_STEP_UP_ROUTES` de `apps/api/src/admin-app.ts`):
// quem abre o `StepUpDialog` e reexecuta a chamada é `api/client.ts`. Não há diálogo de
// confirmação, o croqui não desenha um, o step-up já é a confirmação e dois modais
// empilhados (Radix por cima do `vaul`) brigam pelo foco.

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';
import {
  ADMIN_INBOX_QUERY_KEY,
  inboxItemOptions,
  reprocessInbox,
} from '../api/queries/admin-webhooks.ts';
import { InboxEventDetail } from '../features/admin-webhooks/inbox-detail.tsx';
import {
  isStepUpCancelled,
  REPROCESS_QUEUED,
  reprocessErrorMessage,
} from '../features/admin-webhooks/model.ts';

function InboxEvent() {
  const { id } = Route.useParams();
  const queryClient = useQueryClient();
  const [message, setMessage] = useState<{ ok: boolean; text: string } | undefined>(undefined);

  const detail = useQuery(inboxItemOptions(id));

  const reprocess = useMutation({
    mutationFn: async () => {
      setMessage(undefined);
      return reprocessInbox(id);
    },
    onSuccess: () => {
      setMessage({ ok: true, text: REPROCESS_QUEUED });
    },
    onError: (error) => {
      if (!isStepUpCancelled(error)) {
        setMessage({ ok: false, text: reprocessErrorMessage(error) });
      }
    },
    onSettled: async () => {
      await queryClient.invalidateQueries({ queryKey: [ADMIN_INBOX_QUERY_KEY] });
    },
  });

  return (
    <InboxEventDetail
      detail={detail.data}
      isLoading={detail.isPending}
      error={detail.error}
      onRetry={() => {
        void detail.refetch();
      }}
      onReprocess={() => {
        reprocess.mutate();
      }}
      isReprocessing={reprocess.isPending}
      {...(message === undefined ? {} : { message })}
    />
  );
}

export const Route = createFileRoute('/admin/webhooks/inbox/$id')({ component: InboxEvent });
